import React from "react";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import {LlmRunBatchInfo} from "common/flowmaster/types/llm_run";
import Chip from "@material-ui/core/Chip";

interface Props {
  batches: LlmRunBatchInfo[];
  selectedBatches: string[];
  setSelectedBatches: (batchIds: string[]) => void;
}

export default function BatchSelector({
  batches,
  selectedBatches,
  setSelectedBatches,
}: Props) {
  const handleChangeMultiple = event => {
    event.preventDefault();
    const {value} = event.target;
    setSelectedBatches(value);
  };

  return (
    <div>
      <FormControl>
        <InputLabel id="batch_selector-label">Batches</InputLabel>
        <Select
          style={{
            minWidth: "20em",
          }}
          labelId="batch_selector-label"
          id="batch_selector"
          multiple
          value={selectedBatches}
          onChange={handleChangeMultiple}
          input={<Input />}
          renderValue={(selected: string[]) => (
            <div>
              {selected.map(selectedBatchId => {
                const batch = batches.find(
                  batch => batch.batch_id === selectedBatchId,
                );
                if (!batch) {
                  return null;
                }
                return <Chip key={batch.batch_id} label={batch.batch_id} />;
              })}
            </div>
          )}
        >
          {batches.map(batch => (
            <MenuItem key={batch.batch_id} value={batch.batch_id}>
              <span>{batch.batch_id}</span>
              <span>
                {batch.different_issues.length ? (
                  batch.different_issues.map(issue => (
                    <Chip key={issue.id} size="small" label={issue.name} />
                  ))
                ) : (
                  <Chip size="small" label="Unknown" />
                )}
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
